// extracted by mini-css-extract-plugin
module.exports = {"progress":"style_progress_2M4uD","done":"style_done_1x5t7"};